// Small status next to the title of a checklist / foto card.
//   status: "saved" | "unsaved" | null (nothing to tell yet, e.g. a card that was never filled in)
const SavedBadge = ({ status }) => {
  if (status === "saved") {
    return (
      <span className="row-start-center gap-1 text-xs font-semibold text-emerald-600 shrink-0">
        <i className="pi pi-check-circle text-xs"></i>
        Tersimpan
      </span>
    );
  }

  if (status === "unsaved") {
    return (
      <span className="row-start-center gap-1 text-xs font-semibold text-amber-600 shrink-0">
        <i className="pi pi-exclamation-circle text-xs"></i>
        Belum disimpan
      </span>
    );
  }

  return null;
};

export default SavedBadge;
